import React from 'react';
import DataViewerFieldBase, { DataViewerFieldBaseProps } from './DataViewerFieldBase';

export interface DataViewerFieldProps<V = any, K extends keyof V = any> extends DataViewerFieldBaseProps {
    prop: K;
    render?: (value: V[K]) => React.ReactNode;
}

export default class DataViewerField<V = any, K extends keyof V = any> extends DataViewerFieldBase<DataViewerFieldProps<V, K>> {}
